{
  "id": 38,
  "location": "paris",
  "difficulty": "hard",
  "moves": 21,
  "kinds": 6,
  "goals": [
    { "type": "mud" },
    { "type": "collect", "kind": "cupcake", "count": 40 }
  ],
  "stars": [4440, 5710],
  "board": [
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". . . . . . . .",
    ". x x x x x x .",
    ". . . . . . . ."
  ],
  "calibration": { "runs": 1000, "winRate": 0.495, "movesLeft": 3.6, "closeLosses": 0.109, "target": 0.5 }
}
